import React from 'react';

import { useRecoilValue } from 'recoil';

import { FLOW_TYPE } from 'constants/flow';
import { selectedNodeState } from 'state/atoms';
import CSVNodeViewer from './CSVNodeViewer/CSVNodeViewer';
import ImageNodeViewer from './ImageNodeViewer/ImageNodeViewer';

const NodeInfoViewer = () => {
  const selectedNode = useRecoilValue(selectedNodeState);

  return (
    <>
      {selectedNode?.type === FLOW_TYPE.NODE.DATA_NODE && selectedNode.data.prefix === 'csv' && (
        <CSVNodeViewer node={selectedNode} />
      )}
      {selectedNode?.type === FLOW_TYPE.NODE.DATA_NODE && selectedNode.data.prefix === 'image' && (
        <ImageNodeViewer node={selectedNode} />
      )}
    </>
  );
};

export default React.memo(NodeInfoViewer);
